import { sendRequestToServer } from "@src/utility_functions/database_operations/sendRequestToServer";

export const createUser = async (userObject) => {
  const returnObject = sendRequestToServer(
    userObject,
    "/server/database_operations/users/createUser",
  );
  return returnObject;
};
